import useLocalStorageState, { type LocalStorageOptions } from 'use-local-storage-state';

import { LOCAL_STORAGE_PREFIX } from '@/config';

export const usePersistState = <T>(key: string, options?: LocalStorageOptions<T>) =>
  useLocalStorageState(`${LOCAL_STORAGE_PREFIX}${key}`, options);
